import { styled, Typography } from '@material-ui/core';

export const CustomTypograhy = styled(Typography)(({ theme }) => ({
  lineHeight: '1rem',

  [theme.breakpoints.up('sm')]: {
    lineHeight: '1.2rem',
  },

  '&.MuiTypography-h3': {
    fontSize: '12px !important',
    fontWeight: '600 !important',
    [theme.breakpoints.up('sm')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '16px !important',
    },
  },

  '&.MuiTypography-h4': {
    fontSize: '10px !important',
    fontWeight: '500 !important',
    [theme.breakpoints.up('sm')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '14px !important',
    },
  },

  '&.MuiTypography-subtitle1': {
    fontSize: '10px !important',
    [theme.breakpoints.up('sm')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '14px !important',
    },
  },

  '&.MuiTypography-subtitle2': {
    fontSize: '8px !important',
    [theme.breakpoints.up('sm')]: {
      fontSize: '10px !important',
    },
  },
}));
